import "./bootstrap";
import * as Sentry from "@sentry/browser";
import EmblaCarousel from "embla-carousel";

const isReactNativeWebView =
    typeof window !== "undefined" && !!window.ReactNativeWebView;

const sentryIntegrations = [Sentry.browserTracingIntegration()];

if (!isReactNativeWebView) {
    sentryIntegrations.push(Sentry.replayIntegration());
}

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    environment: import.meta.env.VITE_APP_ENV,
    integrations: sentryIntegrations,
    replaysSessionSampleRate: isReactNativeWebView ? 0 : 0.1,
    replaysOnErrorSampleRate: isReactNativeWebView ? 0 : 1.0,
});

window.EmblaCarousel = EmblaCarousel;

import {
    Livewire,
    Alpine,
} from "../../vendor/livewire/livewire/dist/livewire.esm";
import Autosize from "@marcreichel/alpine-autosize";

Alpine.directive("clipboard", (el) => {
    let text = el.textContent;

    el.addEventListener("click", () => {
        navigator.clipboard.writeText(text);
    });
});

Alpine.plugin(Autosize);

document.addEventListener("livewire:navigate", (event) => {
    let context = event.detail;

    if (context.history === true) {
        event.preventDefault();
        window.location.href = context.url.href;
    }
});

document.addEventListener("livewire:navigated", () => {
    // Check if there is a target query parameter in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const target = urlParams.get("target");

    // If there is a target query parameter, scroll to the target element
    if (target) {
        const targetElement = document.getElementById(target);

        if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth" });
        }
    }

    const webView = window.ReactNativeWebView;

    if (webView && webView.postMessage) {
        webView.postMessage(
            JSON.stringify({
                type: "navigated",
            }),
        );
    }
});

document.addEventListener("livewire:init", () => {
    Livewire.on("response-deleted", (event) => {
        const element = document.getElementById(`response-${event[0]}`);

        if (element) {
            element.remove();
        }
    });

    Livewire.on("pause-deleted", (event) => {
        const element = document.getElementById(`pause-${event[0]}`);

        if (element) {
            element.remove();
        }
    });

    Livewire.on("send-app-message", (data) => {
        if (
            window.ReactNativeWebView &&
            window.ReactNativeWebView.postMessage
        ) {
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
        }
    });
});

Livewire.start();
